module.exports = __webpack_public_path__ + "img/hohlsaum_weiss-transluzent.0388b8fe.jpg";